import React, { useEffect, useState, useRef } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  Divider,
  Modal,
  Fade,
  Box,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import DoneImage from "../Images/doneicon.png";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import PdfModal from "../Components/PdfModal/PdfModal";
import WebcamDemo from "../Components/CameraModule/WebCamFaceDetection";
import {
  startOverAPICall,
  stageDetailsAPICall,
  FromSubmitAPICall,
  FromFillAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import ESignStyles from "../pages/Styles/Esign.module.scss";
import AadhaarImage from "../Components/assets/Images/esignnewimage.svg";
import PDFViewerIframe from "../Components/PDFIframe/PDFWithIframe";
import CloseIcon from "@mui/icons-material/Close";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";
import SnackBar from "../Components/SnackBars/SnackBar";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import BackDrop from "../Components/BackDrop";
import esignImage from "../Components/assets/Images/esignnewimage.jpg";
import { confirmAlert } from "react-confirm-alert";
import backicon from "../Components/assets/Images/back.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  padding: "10px 0px 0px 5px",
};

export default function EsignPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);

  const [backButton, setBackButton] = useState("");
  const [rejectMessage, setRejectMessage] = useState("");
  const [pdfUrl, setpdfUrl] = useState("");
  const [backdrop, setBackDrop] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [continueEsignLoading, setcontinueEsignLoading] = useState(false);

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);

    checkUserLoggedIn(navigate);

    setInitialLoad(true);
    handleGenerateForm();
  }, []);

  const handleGenerateForm = () => {
    FromFillAPICall()
      .then((response: any) => {
        console.log("frormfill", response);
        let obj: any = {
          stage: "form_preview",
        };
        setloading(false);
        stageDetailsAPICall(obj)
          .then((response: any) => {
            const responseData = response.data;
            console.log("res", responseData);
            setInitialLoad(false);
            dispatch(setCompletedStages(responseData?.data?.completed_stages));
            dispatch(setCurrentStage(responseData?.data?.current_stage));
            setRejectMessage(response.data.data.ErrorMessage);

            if (response.data.data.data?.url) {
              setpdfUrl(response.data.data.data?.url);
            }
          })
          .catch((error: any) => {
            setInitialLoad(false);
            // console.log("error", error);
          });
      })
      .catch((error: any) => {
        setloading(false);
        setInitialLoad(false);
        setErrorMessage(
          error.message.includes("Network")
            ? "Something went wrong, contact support"
            : error.response.data.message
        );

        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  };
  const handleSubmitForm = () => {
    setloading(true);
    FromSubmitAPICall()
      .then((response: any) => {
        setloading(false);
        if (
          response.data.data.next_stage &&
          navigationData.hasOwnProperty(response.data.data.next_stage)
        ) {
          navigate(navigationData[response.data.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  return (
    <div className={ESignStyles.mainWrapperTop}>
      <ErrorSnackBar message={rejectMessage} />
      <SnackBar message={errorMessage} />
      {initialLoad && <BackDrop />}

      <div className={ESignStyles.wrapper}>
        <div
          className={ESignStyles.back}
          onClick={() => {
            navigate("/uploaddocuments");
          }}
        >
          <img src={backicon} />{" "}
          <span className={ESignStyles.backText}>Back</span>
        </div>
        <div className={ESignStyles.titleSection}>
          <p className={ESignStyles.almostThereText}>Application Preview</p>
        </div>

        <div className={ESignStyles.modalContainer}>
          <div className={ESignStyles.pdfMobilePreview}>
            <img
              src={esignImage}
              style={{
                width: "95%",
                height: "100%",
                objectFit: "inherit",
                // filter: "brightness(80%)",
                border: "5px solid #525659",
                marginBottom: "20px",
              }}
            />
          </div>
          <div className={ESignStyles.pdfDesktopPreview}>
            <PDFViewerIframe urldata={pdfUrl} />
          </div>
          <Stack marginTop={"20px"} direction={"row"}>
            <LoadingButton
              loading={continueEsignLoading}
              variant="contained"
              sx={{
                width: "150px",
                margin: "auto",
                height: "50px",
              }}
              onClick={handleSubmitForm}
            >
              Submit
            </LoadingButton>
            <a
              href={pdfUrl}
              download="Esign-PDF-document"
              target="_blank"
              rel="noreferrer"
              className={ESignStyles.previewdownlaodesign}
            >
              <Button
                variant="outlined"
                sx={{
                  color: "#1F2937",
                  height: "50px",
                }}
              >
                View Esign PDF
              </Button>
            </a>
          </Stack>
        </div>
      </div>
    </div>
  );
}
